export const TRANSLATION_GROUP_AFFILIATES_PROFILE = Symbol('affiliates.profile');

export const AFFILIATE_PROFILE_GET_URL = 'admin/affiliates/:id/show_settings';
export const AFFILIATE_PROFILE_GET_QUERY_KEY = 'affiliates.profile.get';
